<template>
    <v-layout column align-center class="text-center brown--text">
        <h4 class="tit tit--xs tit--underline mb-4 mb-md-6" data-aos="fade-up">
            <span>당첨을 축하드립니다!</span>
        </h4>
        <v-sheet width="792" max-width="100%" data-aos="fade-up" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 50 : 0">
            <div class="winner-slide txt txt--sm txt txt--sm text-left brown--text">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div v-for="log in logs" :key="log._id" class="swiper-slide">
                            <v-layout align-center fill-height class="winner-slide__inner">
                                <div class="winner-slide__inner__col winner-slide__inner__col--image">
                                    <img :src="`${log?.config?.image}`" />
                                </div>
                                <div class="winner-slide__inner__col">
                                    <p class="font-weight-bold">
                                        {{ log?.config?.name }}
                                    </p>
                                </div>
                                <div class="winner-slide__inner__col">
                                    <p>
                                        {{ maskUsername(log?.user?.username) }}
                                    </p>
                                </div>
                                <div class="winner-slide__inner__col">
                                    <p>
                                        {{ maskName(log?.user?.name) }}
                                    </p>
                                </div>
                                <div class="winner-slide__inner__col">
                                    <p>
                                        {{ $dayjs(log?.createdAt).format("MM/DD") }}
                                    </p>
                                </div>
                            </v-layout>
                        </div>
                    </div>
                </div>
            </div>
        </v-sheet>
        <v-sheet width="792" max-width="100%" data-aos="fade-up" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 50 : 0" class="mt-4">
            <div class="winner-slide txt txt--sm txt txt--sm text-left brown--text">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div v-for="log in ranking" :key="log._id" class="swiper-slide">
                            <v-layout align-center fill-height class="winner-slide__inner">
                                <div class="winner-slide__inner__col winner-slide__inner__col--image">
                                    <img :src="`${log?.config?.image}`" />
                                </div>
                                <div class="winner-slide__inner__col">
                                    <p class="font-weight-bold">
                                        {{ log?.config?.name }}
                                    </p>
                                </div>
                                <div class="winner-slide__inner__col">
                                    <p>
                                        {{ maskUsername(log?.user?.username) }}
                                    </p>
                                </div>
                                <div class="winner-slide__inner__col">
                                    <p>
                                        {{ maskName(log?.user?.name) }}
                                    </p>
                                </div>
                            </v-layout>
                        </div>
                    </div>
                </div>
            </div>
        </v-sheet>
    </v-layout>
</template>
<script>
export default {
    props: {
        logs: { type: Array, default: () => [] },
        ranking: { type: Array, default: () => [] },
    },
    data() {
        return {};
    },
    mounted() {
        this.init();
    },
    methods: {
        maskUsername(name) {
            const len = name.length;
            if (len <= 3) {
                return `${name[0]}***`;
            } else {
                const maskedLen = len - 3;
                return name.substring(0, 3) + "***";
            }
        },
        maskName(name) {
            if (name.length == 1) {
                return "*";
            }
            if (name.length == 2) {
                return `${name[0]}*`;
            }

            const firstChar = name[0];
            const lastChar = name[name.length - 1];
            const maskedName = firstChar + '*'.repeat(name.length - 2) + lastChar;
            return maskedName;
        },
        async init() {
            this.$nextTick(() => {
                setTimeout(function(){
                    const swiperSlide = new window.Swiper(".winner-slide .swiper-container", {
                        direction: "vertical",
                        slidesPerView: 4,
                        speed: 1000,
                        loop: true,
                        autoplay: {
                            delay: 500,
                            disableOnInteraction: false,
                        },
                    });
                }, 100);
            });            
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_event.scss";

.tit--underline{
    position: relative;
    width: fit-content;
    padding: 0 5px;
    margin: 0 auto;
    >span{
        position: relative;
        z-index: 1;
    }
    &::before{
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 14px;
        background-color: #F6CD8F;
        bottom: 0;
        left: 0;
        z-index: 0;
    }
}

.winner-slide{
    margin: 0 -12px;
    background-color: #fff;
    position: relative;
    &::after{
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: #fff;
        bottom: 0;
        left: 0;
        z-index: 5;
    }
    .swiper-container{
        height: 208px;
    }
    .swiper-slide{
        background-color: #fff;
        max-height: 52px;
        height: 52px;
        border-bottom: 1px solid #9E7345;

    }
    &__inner{
        margin: 0 auto;
        max-width: 640px;
        &__col{
            padding: 0 10px;
            &:nth-child(1){
                width: 12%;
                min-width: 60px;
            }            
            &:nth-child(2){
                width: 34%;
            }            
            &:nth-child(3){
                width: 27%;
            }            
            &:nth-child(4){
                width: 27%;
            }
            &--image{
                max-height: calc(100% - 10px);
                img{
                    display: block;
                    max-width: 100%;
                    margin: 0 auto;
                }
            }
        }
    }
    .swiper-slide:last-child{
        .winner-slide__inner{
            border-bottom: 0;
        }
    }
}
@media (min-width:576px){
}
@media (min-width:768px){
    .tit--underline{
        &::before{
            height: 19px;
        }
    }

    .winner-slide{
        margin: 0;
        &__inner{
            &__col{
                padding: 0 14px;   
            }
        }
    }
}
@media (min-width:1024px){
}
@media (min-width:1200px){
}

</style>
